import NetInfo from "@react-native-community/netinfo";
export const isNetworkConnected = async () => {
    const state = await NetInfo.fetch();
    return state.isConnected;
};
//# sourceMappingURL=isNetworkConnected.js.map